import types from '../../../mutation-types';
import { fraseDaRecusa } from 'dashboard/helper/recusaDoAcesso';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnParticipatingView = ({ route: { name: routeName } }) => {
  const PARTICIPATING_ROUTES = [
    'conversation_participating',
    'conversation_through_participating',
  ];
  return PARTICIPATING_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  context.commit(types.SET_ALL_CONVERSATION, conversationList);
  context.dispatch('conversationStats/set', metaData);
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: !conversationList.length,
  });
};

// ACESSO-01 (L8a): a recusa do acesso à lista (403 `escopo_ausente`) para o "carregando", que só o sucesso limpava
// (acima), e guarda a frase, que a tela mostra no lugar de "não há conversas". Outra falha segue como hoje: a lista
// espera a próxima carga, como a do ReconnectService.
export const handleListRefusal = (commit, error) => {
  const frase = fraseDaRecusa(error);
  if (!frase) return;
  commit(types.SET_LIST_REFUSAL, frase);
  commit(types.CLEAR_LIST_LOADING_STATUS);
};

// ACESSO-01 (L11b): a conversa recusada pelo acesso (403 `escopo_ausente` no `conversations#show` ou nas mensagens,
// quando a pessoa não alcança a conversa) guarda a frase, que a caixa da conversa mostra no lugar dela. Outra falha
// segue como hoje: a ação engole o erro, e a caixa mostra o que mostrava.
export const handleConversationRefusal = (commit, error) => {
  const frase = fraseDaRecusa(error);
  if (frase) commit(types.SET_CONVERSATION_REFUSAL, frase);
};
